export default {
  wrapperColor: Styles.color.grey.one,
};
